import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { InboundDeliveryDetailsTimeFragment } from "../../../../../../models/autogenerated-deliveryService-gql/graphql";
import "./DetailsTimeline.scss";

interface DetailsTimelineProps {
  times: InboundDeliveryDetailsTimeFragment[];
}

const DetailsTimeline = (props: DetailsTimelineProps) => {
  const { t } = useTranslation();
  const { times } = props;

  const timesSortedAsc = [...times].sort(
    (a, b) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime(),
  );

  const renderDateTime = (dateTime: string) =>
    moment(new Date(dateTime)).format(t("dateTimeYearFormat"));

  const renderTimelineItem = (
    item: InboundDeliveryDetailsTimeFragment,
    index: number,
  ) => {
    const { dateTime, category, type } = item;

    return (
      <TimelineItem key={index}>
        <TimelineOppositeContent color="text.secondary">
          {renderDateTime(dateTime)}
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>{`${type} - ${category}`}</TimelineContent>
      </TimelineItem>
    );
  };

  return (
    <Timeline className="timeline" position="right">
      {timesSortedAsc.map((time, index) => {
        return renderTimelineItem(time, index);
      })}
    </Timeline>
  );
};
export default DetailsTimeline;
